   // Styling service Sec
$(document).ready(function(){
$('.offerItemTitle').click(function(){
  $(this).parents('.offerslide').children('.offerItem').removeClass('active');
  $(this).parents('.offerslide').children('.offerItem').children('.offerItemTitle').removeClass('hide');
  $(this).parent('.offerItem').addClass('active');
  $(this).parent('.offerItem').find('.slick-arrows').addClass('z-index-1');
  // $(this).addClass('hide');
});
   // Quote Sec
$('.single-item').slick({
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  appendArrows: false
});
  
//about club section
$('.about-club-slider').slick({
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  adaptiveHeight: true,
  arrows: true,
  prevArrow: "<div class='about-club-prev'><svg xmlns='http://www.w3.org/2000/svg' width='24' height='25' viewBox='0 0 24 25' fill='none'><path d='M20 11.3887H7.83L13.42 5.79867L12 4.38867L4 12.3887L12 20.3887L13.41 18.9787L7.83 13.3887H20V11.3887Z' fill='black'></path></svg></div>",
  nextArrow: "<div class='about-club-next'><svg xmlns='http://www.w3.org/2000/svg' width='24' height='25' viewBox='0 0 24 25' fill='none'><path d='M12 4.38867L10.59 5.79867L16.17 11.3887H4V13.3887H16.17L10.59 18.9787L12 20.3887L20 12.3887L12 4.38867Z' fill='black'></path></svg></div>"
});
  
$('.single-item-quote-img').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  fade: true,
  asNavFor: '.single-item-quote',
   adaptiveHeight: true
});
$('.single-item-quote').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  asNavFor: '.single-item-quote-img',
  dots: false,
  arrows: false,
  adaptiveHeight: true
});

  $('.fxv-single-item-quote-img').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    asNavFor: '.fxv-single-item-quote',
    adaptiveHeight: true
  });

  /* START : 5 March 2026 - Byteam fxV for stylist homepage testimonial */
$('.fxv-single-item-quote').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  asNavFor: '.fxv-single-item-quote-img',
  dots: false,
  arrows: false,
  adaptiveHeight: true
});

$('.fxv-quote-next-btn').click(function () {
      $('.single-item, .fxv-single-item-quote-img').slick('slickNext');
});

$('.fxv-quote-prev-btn').click(function () {
    $('.single-item, .fxv-single-item-quote-img').slick('slickPrev');
});
 /*END : 5 March 2026 - Byteam fxV */
  
   $('.quote-next-btn').click(function () {
        $('.single-item, .single-item-quote-img').slick('slickNext');
    });

    $('.quote-prev-btn').click(function () {
        $('.single-item, .single-item-quote-img').slick('slickPrev');
    });
   
   // Must Have Sec
  $('.multiple-item').slick({
      infinite: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      appendArrows: false,
      responsive: [
          {
          breakpoint: 1500,
          settings: {
              slidesToShow: 2
          }
          },
          {
          breakpoint: 768,
          settings: {
              slidesToShow: 1
          }
          }
      ]
  });
  $('.next-btn').click(function () {
  $('.multiple-item').slick('slickNext');
  });

  $('.prev-btn').click(function () {
      $('.multiple-item').slick('slickPrev');
  });

    // Slider Sec
  $('.slider-item').slick({
      infinite: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      appendArrows: false,
    dots: true,
      responsive: [
          {
          breakpoint: 1500,
          settings: {
              slidesToShow: 3
          }
          },
          {
          breakpoint: 768,
          settings: {
              slidesToShow: 1
          }
          }
      ]
  });
  $('.slide-next-btn').click(function () {
  $('.slider-item').slick('slickNext');
  });

  $('.slide-prev-btn').click(function () {
      $('.slider-item').slick('slickPrev');
  });

//mega mennu 
// $('.mega-menu__list li').click( function(e){
//   e.preventDefault();
//   $('.mega-second-column').addClass('hide');
//   $(this).find('.mega-second-column').removeClass('hide');
// });
$('.mega-menu__list li').hover( function(e){
  $('.mega-second-column').addClass('hide');
  $(this).find('.mega-second-column').removeClass('hide');
});  


});


$('#tabs-nav li:first-child').addClass('active');
$('.tab-content').hide();
$('.tab-content:first').show();

// Click function
$('#tabs-nav li').click(function(){
  $('#tabs-nav li').removeClass('active');
  $(this).addClass('active');
  $('.tab-content').hide();
  
  var activeTab = $(this).find('a').attr('href');
  $(activeTab).fadeIn();
  return false;
});

function showMeet(meetId) {
  // Hide all meets
  var meets = document.querySelectorAll('.meet-content');
  meets.forEach(function(meet) {
    meet.classList.remove('active');
  });

  // Show the selected meet
  var selectedMeet = document.getElementById(meetId);
  selectedMeet?.classList.add('active');


    var tabs = document.querySelectorAll('.meet');
    tabs.forEach(function(tab) {
      tab.classList.remove('active-meet');
      if (tab.getAttribute('onclick').includes(meetId)) {
        tab.classList.add('active-meet');
      }
    });
  }
    showMeet('meet1');

   


function openService(evt, serviceName) {
  var i, tabcontent, tablinks;
  tabcontent = document.getElementsByClassName("service-tab-content");
  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = "none";
  }
  tablinks = document.getElementsByClassName("tablinks");
  for (i = 0; i < tablinks.length; i++) {
    tablinks[i].className = tablinks[i].className.replace(" active", "");
  }
  document.getElementById(serviceName).style.display = "block";
  evt.currentTarget.className += " active";
}
document.getElementById("defaultOpen")?.click();